export const getSetOfPolylines = (mapData) => {
    const setOfPolylines = [];
    let previousCoordinate;
    mapData.forEach((row) => {
        let currentIndex = 0;
        const decodedRowPath = google.maps.geometry.encoding.decodePath(row.encoded_polyline);
        row.map_markers.forEach((mapMarker) => {
            // Rows with 0 polyline_ct still have 1 coordinate, map_marker
            const coordinateCt = Math.max(+mapMarker['polyline_ct'], 1);
            const endCoordinatesIndex = currentIndex + coordinateCt;
            const coordinates = decodedRowPath.slice(currentIndex, endCoordinatesIndex);
            currentIndex = endCoordinatesIndex;
            const marker = new google.maps.LatLng(mapMarker.coordinate.lat, mapMarker.coordinate.lng);
            // this was causing the issue found here: https://gitlab.com/my-virtual-mission/mvm/-/issues/1876
            // I have left it here in case it effects something that I have not seen while testing.
            // Handle non snap-to-route polylines
            // if (coordinateCt === 1) {
            // coordinates.push(marker); 
            // }
            const path = previousCoordinate ? [previousCoordinate, ...coordinates] : coordinates;
            setOfPolylines.push({
                path: path,
                style: mapMarker['style'],
                markerLatLng: marker,
            });
            const [lastCoordinate] = path.slice(-1);
            // Use marker in the first set of polylines as path = [], therefore, lastCoordinate is undefined
            previousCoordinate = lastCoordinate || marker;
        });
    });
    return setOfPolylines;
};
